import {Base} from "@/api/Base"

export class EmployeeEntryRecordAdd extends Base {
    path = "employeeEntryRecord/add"
}